<template>
    <div>
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
            <el-tab-pane label="店铺信息" name="shopInfo"></el-tab-pane>
            <el-tab-pane label="收银台设置" name="cashierConfig"></el-tab-pane>
            <el-tab-pane label="小票打印设置" name="ticketPrinting"></el-tab-pane>
        </el-tabs>
        <router-view class="router-view"></router-view>
    </div>
</template>

<script lang="ts">
import { createComponent, ref } from "@vue/composition-api"
import { routerUtil } from '@/utils/routerUtil'

export default createComponent({
    setup(props, ctx) {
        const {
            activeTabName,
            handleTabClick
        } = routerUtil(ctx)

        return {
            activeTabName,
            handleTabClick
        }
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
    margin-bottom: 12px;
}

.router-view {
    height: calc(100vh - 134px);
}
</style>
